import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { useSuperIntl } from "../_";
import { MenuOutlined, SearchOutlined } from '@ant-design/icons';
import { useEventListener } from 'ahooks/es';
import { AutoComplete, Badge, Dropdown, Empty, Input, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import _ from 'lodash';
import React, { useRef, useState } from 'react';
import { useStyles } from "./Searcher.style";
export var SuperProTableSearcher = function SuperProTableSearcher(properties) {
  var _find, _properties$context$p2, _properties$context$p3;
  var changeParameters = function changeParameters(key, value) {
    var _properties$context$p;
    //
    var chips = (_properties$context$p = properties.context.parameters[0].searcher) !== null && _properties$context$p !== void 0 ? _properties$context$p : [];
    //
    chips = chips.filter(function (chip) {
      return chip.key !== key;
    });
    //
    properties.context.parameters[1]({
      searcher: [].concat(_toConsumableArray(chips), [{
        key: key,
        value: value,
        operator: '≈'
      }])
    });
  };
  var container = useRef(null);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    content = _useState2[0],
    setContent = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    counter = _useState4[0],
    setCounter = _useState4[1];
  var _useState5 = useState('auto'),
    _useState6 = _slicedToArray(_useState5, 2),
    field = _useState6[0],
    setField = _useState6[1];
  var fixedWidth = 320;
  var intl = useSuperIntl();
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  var _useState7 = useState((properties.columns || []).map(function (element) {
      return {
        label: element.title,
        value: element.dataIndex,
        valueType: element.valueType
      };
    }).map(function (element) {
      return _objectSpread(_objectSpread({}, element), {}, {
        _label_: element.label,
        _value_: element.value
      });
    })),
    _useState8 = _slicedToArray(_useState7, 2),
    tips = _useState8[0],
    setTips = _useState8[1];
  var resetTips = function resetTips(value) {
    if (value) {
      setTips((tips || []).map(function (tip) {
        return _objectSpread(_objectSpread({}, tip), {}, {
          value: "".concat(tip._value_, "\xA7").concat(value),
          label: /*#__PURE__*/React.createElement(Typography, {
            style: {
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, /*#__PURE__*/React.createElement(Typography.Text, {
            ellipsis: true,
            style: {
              maxWidth: '40%'
            }
          }, tip._label_), /*#__PURE__*/React.createElement(Typography.Text, {
            type: "secondary",
            ellipsis: true,
            style: {
              maxWidth: '60%'
            }
          }, value))
        });
      }));
    } else {
      setTips((tips || []).map(function (tip) {
        return _objectSpread(_objectSpread({}, tip), {}, {
          value: tip._value_,
          label: tip._label_
        });
      }));
    }
  };
  useEventListener('click', function (event) {
    //
    var currentTarget = event.target;
    //
    for (var i = 0; i < 6; i++) {
      if (currentTarget.tagName === 'SUP') {
        //
        properties.context.filtering[0].setTrue();
        //
        break;
      } else {
        currentTarget = currentTarget.parentNode;
      }
    }
  }, {
    target: counter
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: container,
    style: {
      display: 'flex',
      borderRadius: 2,
      width: fixedWidth,
      transition: 'all 0.3s',
      border: '1px solid #C8CACD'
    },
    className: styles.container
  }, /*#__PURE__*/React.createElement(Dropdown, {
    overlayStyle: {
      width: fixedWidth
    },
    menu: {
      items: [{
        key: 'auto',
        label: intl.formatMessage({
          id: 'Automatic Recognition'
        })
      }, {
        type: 'divider'
      }].concat(_toConsumableArray((tips || []).map(function (tip) {
        return {
          label: /*#__PURE__*/React.createElement(Typography, {
            style: {
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, /*#__PURE__*/React.createElement(Typography.Text, {
            ellipsis: true
          }, tip._label_), /*#__PURE__*/React.createElement(Typography.Text, {
            type: "secondary"
          }, _.upperFirst(tip.valueType))),
          key: tip._value_
        };
      }))),
      onClick: function onClick(item) {
        resetTips(content);
        setField(item.key);
      }
    },
    trigger: ['hover'],
    className: styles.selector
  }, /*#__PURE__*/React.createElement(Space, {
    style: {
      color: '#707275'
    }
  }, /*#__PURE__*/React.createElement(MenuOutlined, null), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 80,
      lineHeight: '30px'
    }
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Typography.Text, {
    ellipsis: true
  }, ((_find = (tips || []).find(function (tip) {
    return tip._value_ === field;
  })) === null || _find === void 0 ? void 0 : _find._label_) || intl.formatMessage({
    id: 'Automatic Recognition'
  })))))), /*#__PURE__*/React.createElement(Badge, {
    showZero: true,
    count: (_properties$context$p2 = (_properties$context$p3 = properties.context.parameters[0].searcher) === null || _properties$context$p3 === void 0 ? void 0 : _properties$context$p3.length) !== null && _properties$context$p2 !== void 0 ? _properties$context$p2 : 0,
    className: styles.counter,
    ref: setCounter
  }, /*#__PURE__*/React.createElement(AutoComplete, {
    open: field === 'auto' ? undefined : false,
    value: content,
    options: tips,
    backfill: false,
    onChange: setContent,
    onSelect: function onSelect(value) {
      // 清空输入框
      setContent('');
      // 格式化选项
      // > -
      var parsedValue = value.split('§');
      // > -
      if (parsedValue.length > 1) {
        changeParameters(parsedValue[0], parsedValue[1]);
      }
      // 重设 tips
      resetTips();
    },
    style: {
      width: '100%'
    },
    popupMatchSelectWidth: fixedWidth,
    onSearch: function onSearch(value) {
      return resetTips(value);
    },
    filterOption: function filterOption(inputValue, option) {
      switch (option === null || option === void 0 ? void 0 : option.valueType) {
        case 'digit':
          {
            return !isNaN(parseFloat(inputValue)) && isFinite(inputValue);
          }
        case 'textarea':
        case 'text':
          {
            if ((option === null || option === void 0 ? void 0 : option._value_) === 'uuid') {
              return inputValue.length === 36 && (inputValue.match(/-/g) || []).length === 4;
            } else {
              return true;
            }
          }
        case 'dateTime':
          {
            return dayjs(inputValue).isValid();
          }
        default:
          {
            return false;
          }
      }
    },
    getPopupContainer: function getPopupContainer() {
      return container.current;
    },
    notFoundContent: /*#__PURE__*/React.createElement(Empty, {
      style: {
        margin: '24px 48px'
      }
    }),
    popupClassName: styles.collector
  }, function () {
    //
    var run = function run() {
      if (field === 'auto') {
        console.error('Oops!');
      } else {
        //
        changeParameters(field, content);
        // 清空输入框
        setContent('');
      }
    };
    //
    return /*#__PURE__*/React.createElement(Input, {
      variant: "borderless",
      onPressEnter: run,
      suffix: /*#__PURE__*/React.createElement(SearchOutlined, {
        style: {
          marginLeft: 8,
          cursor: 'pointer'
        },
        onClick: run
      })
    });
  }())));
};